/**
 * coverage — coverage types + amount tiers for the quote form.
 *
 * MUST stay in sync with server/lib/coverage.js (the server is the source of
 * truth and re-validates every submission against its copy). No pricing
 * logic — the amount is just a label the customer selects.
 */

export const COVERAGE = [
  {
    type: 'term',
    label: 'Term Life',
    amounts: ['$50k', '$100k', '$250k', '$500k', '$750k', '$1M', '$2M'],
  },
  {
    type: 'whole',
    label: 'Whole Life',
    amounts: ['$25k', '$50k', '$100k', '$250k', '$500k', '$1M'],
  },
  {
    type: 'universal',
    label: 'Universal Life',
    amounts: ['$50k', '$100k', '$250k', '$500k', '$1M', '$2M'],
  },
  {
    type: 'final_expense',
    label: 'Final Expense',
    amounts: ['$5k', '$10k', '$15k', '$20k', '$25k', '$50k'],
  },
];

const LABELS = Object.fromEntries(COVERAGE.map((c) => [c.type, c.label]));

/** Human label for a coverage type (falls back to the raw type). */
export function labelFor(type) {
  return LABELS[type] || type;
}
